export const MAX_CELL_SIZE = 1024;

export const MAX_ROW = 64;

export const DEFAULT_CELLS = ['%имя% %фамилия%', '%вк_польз%', ''];
